// Translations
import landing from '../views/landing/translations/ar'

// Translation: Two-factor authentication (Arabic)
export default Object.freeze({
	name: '',
	views: { landing }
})
